import { action } from 'typesafe-actions';
import { QueueActionTypes } from './types';

export const readyToBook = (payload: boolean) => action(QueueActionTypes.APP_READY_TO_BOOK, payload);
export const sessionId = (payload: string) => action(QueueActionTypes.SESSION_ID, payload);
export const queueEmail = (payload: string) => action(QueueActionTypes.EMAIL_QUEUE, payload);
export const setIsExistUserInDB = (payload: boolean) => action(QueueActionTypes.IS_USER_EXIST, payload);